import { SET_USER_BOUNTY_BUDGETS, UPDATE_USER_BOUNTY_BUDGET } from './actionTypes'

const initialState = []

export default (state=initialState,  action) => {
    switch(action.type) {
    case SET_USER_BOUNTY_BUDGETS:
        // add in sort here
        return action.budgets
    case UPDATE_USER_BOUNTY_BUDGET:
        let budgetList = [...state]
        budgetList = budgetList.filter(b => b.id === action.budget.id)
        budgetList = [...budgetList, action.budget]
        return budgetList
    default:
        return state
    }
}